import { Typography } from 'seagull';
import { AnchorIcon } from 'seagull/icons';
import { getAccountingDetails, getServiceTemplateMapStatus } from "../accounting.utils";
import styles from "./MapServicesModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const columnDefs = hideType => [{
  width: 400
},
// Anchor service
{
  width: 400
},
// QuickBooks item names
{
  width: 130
},
// Status
{
  width: hideType ? 0 : 130
} // Type
];
export const getHeaderItems = (accounting, hideType) => [{
  value: /*#__PURE__*/_jsxs("div", {
    className: styles.columnHeader,
    children: [/*#__PURE__*/_jsx(AnchorIcon, {
      className: styles.icon
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      children: "Anchor service name"
    })]
  })
}, {
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph2",
      children: [getAccountingDetails(accounting).fullName, " service name"]
    })
  })
}, ...(hideType ? [] : [{
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      "data-testid": "service-template-type-header",
      children: "Type"
    })
  })
}]), {
  value: 'Status'
}];
export function getSearchedServicesAndFilteredOptions(_ref) {
  let {
    services,
    search,
    statusFilters,
    accounting,
    accountingItems
  } = _ref;
  const searchFilteredServices = services.filter(service => applySearch({
    search,
    service
  }));
  const serviceFilterOptions = getServiceFilterOptions({
    services: searchFilteredServices,
    accounting,
    accountingItems
  });
  const filteredServices = searchFilteredServices.filter(service => applyServiceFilterMappingStatus({
    filters: statusFilters,
    service,
    accounting,
    accountingItems
  }));
  return {
    filteredServices,
    serviceFilterOptions
  };
}
export function applySearch(_ref2) {
  let {
    search,
    service
  } = _ref2;
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  const serviceName = service.name.toLowerCase();
  return !normalizedSearch || "".concat(serviceName).includes(normalizedSearch);
}
export function applyServiceFilterMappingStatus(_ref3) {
  let {
    filters,
    service,
    accounting,
    accountingItems
  } = _ref3;
  if (filters.length === 0) {
    return true;
  }
  const serviceStatus = getServiceTemplateMapStatus({
    serviceTemplate: service,
    accounting,
    accountingItems
  });
  return filters.some(status => {
    if (status === 'mapped') {
      return serviceStatus === 'mapped';
    }
    if (status === 'notMapped') {
      return serviceStatus === 'notMapped' || serviceStatus === 'failedToMap';
    }
    return status === serviceStatus;
  });
}
export function getServiceFilterOptions(_ref4) {
  let {
    services,
    accounting,
    accountingItems
  } = _ref4;
  const mappedCount = services.filter(s => getServiceTemplateMapStatus({
    serviceTemplate: s,
    accounting,
    accountingItems
  }) === 'mapped').length;
  const notMappedCount = services.filter(s => getServiceTemplateMapStatus({
    serviceTemplate: s,
    accounting,
    accountingItems
  }) === 'notMapped').length;
  const failedToMapCount = services.filter(s => getServiceTemplateMapStatus({
    serviceTemplate: s,
    accounting,
    accountingItems
  }) === 'failedToMap').length;
  const options = [];
  if (mappedCount > 0) {
    options.push({
      value: 'mapped',
      counter: mappedCount,
      label: 'Yes'
    });
  }
  const noCount = notMappedCount + failedToMapCount;
  if (noCount > 0) {
    options.push({
      value: 'notMapped',
      counter: noCount,
      label: 'No'
    });
  }
  return options;
}
export function getNumMappedServices(services, accounting, accountingItems) {
  if (!accountingItems) {
    return 0;
  }
  return services.filter(s => getServiceTemplateMapStatus({
    serviceTemplate: s,
    accounting,
    accountingItems
  }) === 'mapped').length;
}